import { render, staticRenderFns } from "./EventTagging.vue?vue&type=template&id=4101b5a6&"
import script from "./EventTagging.vue?vue&type=script&lang=js&"
export * from "./EventTagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports